module.exports = __webpack_public_path__ + "img/xingxiang.b9332876.png";